import React from "react";
import { Link } from "react-router-dom";
type FooterColumn = {
  title: string;
  links: {
    to: string;
    label: string;
  }[];
};
const columns: FooterColumn[] = [{
  title: "Services",
  links: [{
    to: "/payroll-operations",
    label: "Payroll Operations"
  }, {
    to: "/hr-technology",
    label: "HR Technology"
  }, {
    to: "/process-controls",
    label: "Process & Controls"
  }]
}, {
  title: "Research",
  links: [{
    to: "/research",
    label: "Research & Intelligence"
  }, {
    to: "/research#maturity-model",
    label: "Payroll Maturity Model™"
  }, {
    to: "/research#state-of-payroll",
    label: "State of Payroll Operations"
  }, {
    to: "/intelligence",
    label: "Constant Intelligence"
  }]
}, {
  title: "The Ledger",
  links: [{
    to: "/ledger?format=Essay",
    label: "Essays"
  }, {
    to: "/ledger?format=Field+Note",
    label: "Field Notes"
  }, {
    to: "/ledger?format=Analysis",
    label: "Analysis"
  }]
}, {
  title: "Company",
  links: [{
    to: "/about",
    label: "About"
  }, {
    to: "/contact",
    label: "Contact"
  }]
}];
export function SiteFooter() {
  return <footer data-id="element-628" data-mp="1ar9k4t21udii">
      <div className="bg-oxblood text-ivory" data-id="element-629" data-mp="1anvhrktdy4b2">
        <div className="shell flex flex-col gap-3 py-6 md:flex-row md:items-center md:justify-between" data-id="element-630" data-mp="vth6k6g2bz6y">
          <p className="eyebrow text-ivory/80" data-id="element-631" data-mp="10stqojfjus5u">How we help</p>
          <p className="font-display text-lg tracking-[0.14em] md:text-xl" data-id="element-632" data-mp="1ohcw8r77squ8">
            RESCUE <span className="text-ivory/50" data-id="element-633" data-mp="1ojpdf255ex68">•</span> IMPLEMENT <span className="text-ivory/50" data-id="element-634" data-mp="1tfeg3ecgsu6r">•</span> OPTIMIZE{" "}
            <span className="text-ivory/50" data-id="element-635" data-mp="1erjqw7xo17yf">•</span> OPERATE
          </p>
        </div>
      </div>

      <div className="bg-navy text-ivory" data-id="element-636" data-mp="1jqmqvdysgnzj">
        <div className="shell pb-10 pt-20 md:pt-24" data-id="element-637" data-mp="1jpbq7n0n3wcn">
          <div className="grid grid-cols-12 gap-x-6 gap-y-14" data-id="element-638" data-mp="27g7b006ohrae">
            <div className="col-span-12 lg:col-span-4" data-id="element-639" data-mp="27ew9k70pgvmg">
              <img src="https://cdn.magicpatterns.com/uploads/c9pCfAFc2Av8M1xDEdAHDB/constant-primary-ivory-on-navy.svg" alt="Constant" className="-ml-4 w-[280px] max-w-full" data-id="element-640" data-mp="2c77and76mngl" />
              <p className="eyebrow mt-8 text-ivory/80" data-id="element-641" data-mp="2h4mfbrf7h3v6">Payroll Operations + HR Technology</p>
              <p className="mt-6 max-w-sm font-display text-xl italic leading-snug text-ivory/85" data-id="element-642" data-mp="2d0oglhtslv2n">
                We make payroll, systems, and process work — quietly, correctly, every time.
              </p>
            </div>

            {columns.map(col => <nav key={col.title} aria-label={col.title} className="col-span-6 md:col-span-3 lg:col-span-2" data-id="element-643" data-mp="1yd3cplp3frto">
                <p className="eyebrow text-ivory/60" data-id="element-644" data-mp="1pcn9mdc9impc">{col.title}</p>
                <ul className="mt-6 space-y-3" data-id="element-645" data-mp="1pehy21mqswy6">
                  {col.links.map(l => <li key={l.to} data-id="element-646" data-mp="1kcsm8jrp4f91">
                      <Link to={l.to} className="text-sm text-ivory/85 transition-colors duration-150 hover:text-ivory hover:underline" data-id="element-647" data-mp="1fehfihwp6kv1">
                        {l.label}
                      </Link>
                    </li>)}
                </ul>
              </nav>)}
          </div>

          <div className="mt-20 flex flex-col gap-3 border-t border-ivory/20 pt-8 text-xs tracking-[0.04em] text-ivory/60 md:flex-row md:items-center md:justify-between" data-id="element-648" data-mp="4u33z74xl7mp">
            <a href="mailto:hello@constantpayroll.com" className="hover:text-ivory" data-id="element-649" data-mp="8tve3o9z3lu6">hello@constantpayroll.com</a>
            <p data-id="element-650" data-mp="3da6b9bs4suai">© 2026 Constant</p>
          </div>
        </div>
      </div>
    </footer>;
}